import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCrmWithProjects } from "./useCreateCrmWithProjects.query";
import { queryKeys } from "@/lib/useQuery/queryKeys";

export function useCreateCrmWithProjects() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["crm_with_projects"],
        mutationFn: createCrmWithProjects,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.crm._def });
            queryClient.invalidateQueries({ queryKey: queryKeys.crm_project._def });
            queryClient.invalidateQueries({ queryKey: queryKeys.crm_config._def });
            queryClient.invalidateQueries({ queryKey: queryKeys.project._def });
            queryClient.invalidateQueries({ queryKey: queryKeys.survey._def });
            queryClient.invalidateQueries({ queryKey: queryKeys.question._def });
        }
    });
}